export default "__VITE_ASSET__CXZU9Aka__"